import { AnyAction } from 'redux';
import { ActionTypes } from '../constants/index';
import { NotesDetails } from '../modal';

export default function reducer(state: NotesDetails = new NotesDetails(),
  action: AnyAction) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.NOTES_DETAILS_LIST_REQUEST:
      return {
        ...state,
        loadingInProgress: true,
      };
    case ActionTypes.NOTES_DETAILS_LIST_SUCCESS:
      return {
        ...state,
        loadingInProgress: false,
        data: payload,
      };
    case ActionTypes.NOTES_DETAILS_LIST_ERROR:
      return {
        ...state,
        loadingInProgress: false,
        loadingError: payload,
      };
    default:
      return state;
  }
}
